import { useGet } from '@ngt/opms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import {
    GetProcomidaProFormLookup,
    GetProcomidaProFormLookupResponse
} from '../../api/dtos';

const getData = (
    response?: SWRResponse<
        GetProcomidaProFormLookupResponse,
        GetProcomidaProFormLookupResponse
    >
) => response?.data?.items;

const getError = (
    response?: SWRResponse<
        GetProcomidaProFormLookupResponse,
        GetProcomidaProFormLookupResponse
    >
) => (response?.error ?? response?.data)?.responseStatus;

const useProcomidaProFormLookup = (
    patientId?: number,
    eventDefinitionId?: number,
    configuration?: SWRConfiguration
) => {
    const request = useMemo(() => {
        if (!patientId || !eventDefinitionId) {
            return undefined;
        }

        return () => new GetProcomidaProFormLookup({
            patientId,
            eventDefinitionId
        });
    }, [patientId, eventDefinitionId]);

    return useGet(request, { getData, getError }, configuration);
};

export default useProcomidaProFormLookup;
